import logo from "@/assets/logo.png";
import { cn } from "@/lib/utils";

interface BrandLogoProps {
  className?: string;
  showName?: boolean;
  name?: string;
}

export function BrandLogo({
  className,
  showName = true,
  name = "GHz Store",
}: BrandLogoProps) {
  return (
    <div className={cn("flex items-center gap-2", className)}>
      <img src={logo} alt="GHz Store" className="size-7 shrink-0 object-contain" />
      {showName && <span className="truncate font-semibold">{name}</span>}
    </div>
  );
}
